import Snackbar from '@mui/material/Snackbar';
import { UIColors } from '../../constants/UIConstants';
import { closeNotification } from '../../redux/slice/snackBarSlice';
import { useAppDispatch, useAppSelector } from '../../redux/store';

function SnackBar() {
  const dispatch = useAppDispatch();
  const snackbar = useAppSelector((state) => state.snackbar);

  const closeSnackbar = () => {
    dispatch(closeNotification());
  };

  const message =
    snackbar.open && snackbar.messageInfo.trim()
      ? snackbar.messageInfo
      : undefined;

  return (
    <Snackbar
      key={message ?? 'closed'}
      open={snackbar.open && Boolean(message)}
      autoHideDuration={6000}
      message={message}
      onClose={closeSnackbar}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      sx={{ zIndex: 2147483647 }}
      ContentProps={{
        sx: {
          background: UIColors.primary.navyBlue,
        },
      }}
    />
  );
}

export default SnackBar;
